import Typography from '@mui/material/Typography';
import React from 'react'
import {typoStyle} from "../styles/globalStyle"


const Reaktifstandart = () => {
  return (
    
    <div>
        <Typography mt={8} align='center' variant='h5' fontWeight={700} sx={typoStyle}>
            Reaktif Standart
        </Typography>
    </div>

  )
}

export default Reaktifstandart